<template>
  <!--================ banner =================-->
  <section v-if="bannerTopo != ''" class="breadcrumb_area">
    <div class="overlay bg-parallax">
      <img :src="$imagens + 'about_banner.jpg'" alt="">
    </div>
    <div class="container">
      <div class="page-cover text-center">
        <h2 class="page-cover-tittle">{{ bannerTopo[0].itiNome }}</h2>
        <ol class="breadcrumb">
          <li><a href="index.html">Home / </a></li>
          <li class="active">{{ bannerTopo[0].itiNome }}</li>
        </ol>
      </div>
    </div>
  </section>

  <!--================Blog Area =================-->
  <section v-if="listaBlog.length > 0" class="blog_area">
    <div class="container">
      <div class="row">
        <!-- primeira noticia -->
        <div class="col-lg-8">
          <div class="blog_left_sidebar">
            <article v-for="noticia in primeiraNoticia" :key="noticia.itiId" class="row blog_item">
              <div class="blog_post">
                <img
                  :style="{ backgroundImage: 'url(' + $imgURL + noticia.insInstitucionalImagens[0].itgUrlImagem + ')' }"
                  class="card-img-avance">
                <div class="blog_details">
                  <router-link :to="'/BlogDetalhe/' + noticia.itiId + '/' + formataLink(noticia.itiNome)"
                    class="d-inline-block">
                    <h2>{{ noticia.itiNome }}</h2>
                  </router-link>
                  <p>{{ resumoCurto(noticia.itiResumo1) }}</p>
                  <div class="button-group-area mt-10">
                    <router-link :to="'/BlogDetalhe/' + noticia.itiId + '/' + formataLink(noticia.itiNome)"
                      class="genric-btn primary-border">
                      Leia mais</router-link>
                  </div>
                </div>
              </div>
            </article>
          </div>
        </div>

        <!-- outras noticias -->
        <div class="col-lg-4">
          <div class="blog_right_sidebar">

            <aside class="single_sidebar_widget popular_post_widget">
              <h3 class="widget_title">Últimas Notícias</h3>
              <div v-for="noticia in listaBlog" :key="noticia.itiId" class="media post_item">
                <img :src="$imgURL + noticia.insInstitucionalImagens[0].itgUrlImagem" alt="" class="post-item-avance">
                <div class="media-body">
                  <router-link :to="'/BlogDetalhe/' + noticia.itiId + '/' + formataLink(noticia.itiNome)"
                    class="d-inline-block">
                    <h3>{{ noticia.itiNome }}</h3>
                  </router-link>
                </div>
              </div>
            </aside>

          </div>
        </div>
      </div>
    </div>
  </section>

</template>

<script>
import { useHead } from '@vueuse/head'
import axios from 'axios';

export default {
  name: 'BlogView',
  components: {
  },

  data: () => ({
    bannerTopo: [],
    listaBlog: [],
  }),

  computed: {
    primeiraNoticia() {
      return this.listaBlog.length > 0 ? [this.listaBlog[0]] : [];
    }
  },

  methods: {
    /* resumo curto da primeira noticia */
    resumoCurto(conteudo) {
      const textoLimpo = this.removerTagsHTML(conteudo);
      const limite = 200; // você pode ajustar esse número
      return textoLimpo.length > limite ? textoLimpo.slice(0, limite) + '...' : textoLimpo;
    },

    /* paginador */
    changePage(page) {
      this.currentPage = page;
      window.scrollTo({ top: 0, behavior: 'smooth' }); // opcional
    },

    formataLink(value) {
      return value.replaceAll('/', '').replaceAll(' ', '-').replaceAll('.', '').replaceAll('+', '');
    },

    carregaMetas(texto, titulo) {
      useHead({
        title: 'Garante Imob - ' + titulo,
        meta: [
          { name: "description", content: texto },
          { name: "author", content: "Garante Imob" },
          { httpEquiv: "Content-Language", content: "pt-BR" },
          { charset: "UTF-8" },
          { name: "robots", content: "index, follow" },
        ],
      })
    },

    removerTagsHTML(html) {
      const element = document.createElement('div');
      element.innerHTML = html;
      return element.textContent || element.innerText || '';
    },

    filtraNoticia(categoria) {
      let _filtro = this.listaNoticias.filter(x => x.itiReferencia == categoria);
      this.firstNoticia = _filtro[0];
      this.otherNoticas = _filtro.slice(1, 6);
      this.finalNoticias = _filtro.slice(7);
    }
  },

  created() {
    this.carregaMetas("---");

    //aqui banner topo
    axios.get('/Process/InsInstitucional/institucional/27/toponoticias/0/x')
      .then(response => {
        this.bannerTopo = response.data;
        this.carregaMetas(this.removerTagsHTML(this.bannerTopo[0].itiReferencia), this.bannerTopo[0].itiNome);
        //console.log('banner blog')
        //console.log(this.bannerTopo)
      })
      .catch(error => {
        console.error(error);
      });
    //aqui busca notícias
    axios.get('/Process/InsInstitucional/institucional/50/noticias/0/itiData1')
      .then(response => {
        this.listaBlog = response.data.filter(x => x.itiVisivel).sort((a, b) => {
          const timeA = a.itiData1
            ? new Date(a.itiData1).getTime()
            : 0;
          const timeB = b.itiData1
            ? new Date(b.itiData1).getTime()
            : 0;
          return timeA - timeB;
        }).reverse();
        //console.log('noticias')
        //console.log(this.listaBlog)
      })
      .catch(error => {
        console.error(error);
      });

  },
}
</script>

<style scoped></style>